import { GET_CUSTOM_ART_LIST, GET_CUSTOM_ART_LIST_FAIL, GET_CUSTOM_ART_LIST_SUCCESS, POST_CUSTOM_ART, POST_CUSTOM_ART_FAIL, POST_CUSTOM_ART_SUCCESS } from "./actionTypes";



/* Verify Collection By Name */
export const postCustomArt = (data, callback) => ({
  type: POST_CUSTOM_ART,
  payload: { data, callback },
});

export const postCustomArtSuccess = () => ({
  type: POST_CUSTOM_ART_FAIL,
});

export const postCustomArtFail = () => ({
  type: POST_CUSTOM_ART_SUCCESS,
});




export const listCustomArt = (data, callback) => ({
    type: GET_CUSTOM_ART_LIST,
    payload: { data, callback },
  });
  
  export const listCustomArtSuccess = (data) => ({
    type: GET_CUSTOM_ART_LIST_SUCCESS,
    payload: data,
  });
  
  export const listCustomArtFail = () => ({
    type: GET_CUSTOM_ART_LIST_FAIL,
  });
